// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2L0N_","errors":"Errors_errors__2phAC"};